import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  aboutText = 'Información general del proyecto';
  tcoText = 'Comparativa entre camión diesel y camión eléctrico';
  faqText = '12 preguntas que debes hacerte si estás considerando comprarte un camión eléctrico';

  constructor() {
  }

  ngOnInit(): void {
  }
}
